import HeaderCell from '../../components/table/HeaderCell';

const columns = ({ onEditOpen }) => [
  {
    id: 1,
    name: <HeaderCell label={"ID"} />,
    selector: (row) => row?.id,
    minWidth: "81px",
    sortable: true,
  },
  {
    id: 2,
    name: <HeaderCell label={"SELLER NAME"} />,
    selector: (row) => row?.full_name,
    minWidth: "200px",
    sortable: true,
  },
  {
    id: 3,
    name: <HeaderCell label={"TOTAL BALANCE"} />,
    selector: (row) => row?.totalBalance,
    cell: (row) => {
      const value = row?.totalBalance;
      const rounded = Math.round((value || 0) * 100) / 100;
      const display = rounded === 0 ? 0 : rounded;
      const color = display === 0 ? "gray" : display > 0 ? "#099E4A" : "red";
      return (
        <span style={{ color }}>
          {display.toFixed(2)}
        </span>
      );
    },
    minWidth: "120px",
    sortable: true,
  },
  {
    id: 4,
    name: <HeaderCell label={"EMAIL ADDRESS"} />,
    selector: (row) => row?.email_address,
    minWidth: "250px",
    sortable: true,
  },
  {
    id: 5,
    name: <HeaderCell label={"ACTION"} />,
    cell: (row) => (
      <img
        src={require('../../assets/svgs/edit-04.svg').default}
        alt="edit"
        style={{ cursor: 'pointer' }}
        onClick={() => onEditOpen(row)}
      />
    ),
    maxWidth: "81px",
  },
]

// const columns = [
// 	columnHelper.accessor("id", {
// 		id: "id",
// 		header: () => "ID",
// 		cell: props => {
// 			return props?.getValue();
// 		  },
// 		size: 81,
// 	}),
// 	columnHelper.accessor("full_name", {
// 		id: "seller_name",
// 		header: () => "Seller Name",
// 		cell: props => props?.getValue(),
// 	}),
// 	columnHelper.accessor(row => row.totalBalance, {
// 		id: "total_balance",
// 		header: () => "Total Balance",
// 		cell: props => {
// 		  const value = props.getValue();
// 		  const color = value < 0 ? "red" : "#099E4A"; 
// 		  return <span style={{ color }}>{formatCurrency(value)}</span>;
// 		},
// 		size: 120,
// 	  }),
	  
// 	columnHelper.accessor("email_address", {
// 		id: "email_address",
// 		header: () => "Email Address",
// 		cell: props => props?.getValue(),
// 	}),
// 	columnHelper.display({
// 		id: "action",
// 		header: () => "Actions",
// 		cell: props => props.row.original.action,
// 		maxSize: 81,
// 	}),
// ];

export { columns };
